import { render, staticRenderFns } from "./ListPartijen.vue?vue&type=template&id=f1ed63b2&"
import script from "./ListPartijen.vue?vue&type=script&lang=js&"
export * from "./ListPartijen.vue?vue&type=script&lang=js&"
import style0 from "./ListPartijen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports